module.exports = __webpack_public_path__ + "static/media/David Pinto.bcf9cba9.jpg";